import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import LoadingButton from "../../../components/elements/LoadingButton";
import {connect} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import SubTitle from "../../../components/elements/SubTitle";
import Thumbnail from "../../fileManager/Components/Thumbnail";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import AlternateEmailRoundedIcon from '@material-ui/icons/AlternateEmailRounded';
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import {updateRedux} from "../../../../config/Security";
import FieldCounter from "../../../components/elements/FieldCounter";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Permission from "../../../components/elements/Permission";
import Layout from "../../../components/layouts/layout";
import Rating from "@material-ui/lab/Rating/Rating";

class MakeShop extends React.Component {
    classes = this.props.classes;
    state={
        fields: {
            name: '',
            instagram:'',
            bio:'',
            description:'',
        },
        errors:{},
        loading:this.props.edit,
        SubmitLoading:false,
        edit:this.props.edit,
        logo: 3,
        cover: 4,
        rating: 0,
        confirmed: 0,
        shop_id:this.props.shop_id
    };
    handleLogoImage(id){
        this.setState({
            logo: id
        })
    }
    handleCoverImage(id){
        this.setState({
            cover: id
        })
    }
    async componentDidMount(){

        if(!!this.state.edit){
            await this.loadData();
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/shop/get/${this.state.shop_id}`, config)
            .then(response => {
                this.setState({
                    fields:{
                        name:response.data.name,
                        bio:response.data.bio,
                        description:!!response.data.description ? response.data.description : '',
                    },
                    logo: response.data.logo.id,
                    cover: response.data.cover.id,
                    confirmed: response.data.confirmed == 1,
                    rating: response.data.rating,
                    loading:false,
                })
            })
            .catch(error => {
                if(error.response.status === 404){
                    this.props.enqueueSnackbar(Translate.dataFetchingError, {
                        variant: 'error',
                    });
                }
                this.setState({
                    loading:false
                })
                console.log(error)
            });
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,

        });
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }else if(!validator.isByteLength(fields.name,{min:0, max:255})){
            formIsValid = false;
            errors['name'] = Translate.maxLength255;
        }

        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 150) {
                formIsValid = false;
                errors['description'] = Translate.maxLength150;
            }
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasErrorPleaseCheckThem, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,logo,cover,shop_id,confirmed,rating} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('bio', fields.bio);
        data.append('description', fields.description);
        data.append('id', shop_id);
        data.append('user_id', this.props.user.id);
        data.append('logo', logo);
        !! this.props.user.role.permission.manageShops && data.append('rating', rating);
        data.append('confirmed', confirmed ? 1 : 0);
        data.append('cover', cover);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/shop/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.detailsSet, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false
                });
                updateRedux();
                if(!this.state.edit){
                    this.props.history.push(`/my-shops`);
                }

            })

            .catch(error => {
                if(error.response.status === 401){
                    this.props.enqueueSnackbar(Translate.someFieldsHasErrorPleaseCheckThem, {
                        variant: 'warning',
                    });
                    let errors = this.state.errors;
                    console.log(error.response);
                    errors['name'] = Translate[error.response.data.name];
                    this.setState({
                        errors
                    })
                }else{
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                }
                console.log(error.response)
                console.log(error)
                this.setState({
                    SubmitLoading:false
                });

            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    render() {
        const {errors,logo,cover,fields,SubmitLoading,edit,confirmed,rating} = this.state;
        const {user} = this.props
        if (this.state.loading) {
            return (
                <AppCardLoaderFields/>
            )
        } else {
            return (
                <React.Fragment>
                    <Grid container  spacing={2} justify="center">
                        <CssBaseline/>
                        <Grid item xs={12} md={11} lg={10}  style={{marginTop:20}}>
                            <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                                <Grid item xs={12}>
                                {
                                    !edit ?
                                            <Alert severity="info">
                                                <AlertTitle>{Translate.welcomeShopCreatorTitle}</AlertTitle>
                                                {Translate.WelcomeShopCreatorText} <strong>{Translate.thankYou}</strong>
                                            </Alert>
                                        :
                                        <>
                                        {
                                            !! user.role.permission.manageShops ?
                                                <>
                                                    <Alert
                                                        severity="info"
                                                        action={
                                                            <FormControlLabel
                                                                style={{marginRight:10}}
                                                                control={
                                                                    <Switch
                                                                        checked={confirmed}
                                                                        onChange={this.handleChangeConfirmed.bind(this)}
                                                                        value={confirmed}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                            />
                                                        }
                                                    >
                                                        {Translate.confirmationStatus}
                                                    </Alert>
                                                    </>
                                                :
                                            confirmed ?
                                               <Alert variant="filled" severity="success">
                                                   {Translate.yourShopIsActive}
                                               </Alert>
                                               :
                                               <Alert variant="filled" severity="warning">
                                                   {Translate.yourShopIsInchecking}
                                               </Alert>
                                        }
                                        </>

                                }
                                </Grid>

                                <Grid item xs={12}>
                                    <SubTitle>{Translate.logo}</SubTitle>
                                    <Thumbnail logo
                                               handleThumbImage={this.handleLogoImage.bind(this)}
                                               initial={logo} size={200}/>
                                </Grid>
                                <Permission rule="manageShops">
                                <Grid item xs={12} className="text-center my-10">
                                    <SubTitle>{Translate.siteRatingDesc}</SubTitle>
                                    <Rating
                                        value={rating}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                rating:newValue
                                            })
                                        }}
                                    />
                                </Grid>
                                </Permission>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        value={fields.name}
                                        fullWidth
                                        id="name"
                                        label={Translate.shopName}
                                        name="name"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['name']}
                                        helperText={errors['name']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.bio}
                                        fullWidth
                                        id="bio"
                                        label={Translate.bio}
                                        name="bio"
                                        autoComplete="bio"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['bio']}
                                        helperText={errors['bio']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.description}
                                        fullWidth
                                        id="description"
                                        label={Translate.shopDescription}
                                        name="description"
                                        multiline
                                        rows={5}
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['description']}
                                        helperText={errors['description']}
                                    />
                                    <FieldCounter length={fields.description.length} max={150}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        onClick = {this.handleSubmit.bind(this)}
                                        loading = {SubmitLoading}
                                    >
                                        {edit ? Translate.setDetails  : Translate.makeShop}
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </React.Fragment>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeShop))));